module.exports = __webpack_public_path__ + "img/GreekTechSpearman2_ua.78ab20e8.webp";